import { Stack } from "@mui/material";
import * as strings from "common/strings";
import * as utils from "utils";

const PrettyInceptionDate = ({ date }) => {
  const formattedDate = utils.formatDate(date);
  const yearStr = formattedDate.slice(-4);
  const prettyDayAndMonth = formattedDate.slice(0, -4);
  const isCurrentYear =
    new Date().getFullYear() === new Date(date).getFullYear();
  return (
    <div className={"inception"}>
      {prettyDayAndMonth}
      <span className={isCurrentYear ? "inception-current-year" : ""}>
        {yearStr}
      </span>
    </div>
  );
};

const SubmissionSummary = ({ program }) => {
  return (
    <div className={"submission-summary"}>
      <Stack>
        <div className={"insured"}>
          {program?.insured ?? "Unknown Submission"}
        </div>
        <div className={"risk-description"}>
          {strings.truncateStringWithEllipsis(
            program?.riskDescription || program?.riskdescription,
            { maxLength: 100 }
          )}
        </div>
        <PrettyInceptionDate date={program?.inception} />
      </Stack>
    </div>
  );
};

export default SubmissionSummary;
